
require.register("react-bootstrap/node_modules/babel-runtime/helpers/interop-require-default.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "react-bootstrap/node_modules/babel-runtime");
  (function() {
    "use strict";

exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
};

exports.__esModule = true;
  })();
});